export default __webpack_public_path__ + "static/media/logo-white.e7860257.png";